module.exports = __webpack_public_path__ + "static/media/03.8f6c3f93.png";